var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.icon.faIcon)?_c('font-awesome-icon',{attrs:{"icon":[_vm.icon.faIcon.iconVariant, _vm.icon.faIcon.iconDescription]}}):_c('SvgIcon',{staticClass:"fa svg-search-type-icon",attrs:{"icon":_vm.icon.customSvg,"fill":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }